import { useState } from "react";

const CashOnDeliveryModal = ({ addressInfo, setAddressInfo,cashOnDeliveryFunction }) => {
    const [open, setOpen] = useState(false);
    
    const handleOpen = () => setOpen(!open);

    return (
        <>

<button
  type="button"
  onClick={handleOpen}
  className="w-full py-3 font-outfit font-semibold flex items-center justify-center gap-2 bg-green-400 text-center  hover:bg-pink-100 rounded-xl transition-all duration-300 ease-in-out"
>Cash on delivery</button> 



            {open && (
                <div className="z-50 fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-300 ease-in-out animate-fadeIn">
                    <div className="bg-pink-50 p-6 rounded-lg w-full max-w-md transform transition-all duration-300 ease-in-out scale-95 animate-slideUp">
                        <h3 className="font-bold text-lg mb-4">Billing Details</h3>

                        <div className="mb-3">
                            <label className="block font-medium">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={addressInfo.name}
                                onChange={(e) => setAddressInfo({ ...addressInfo, name: e.target.value })}
                                placeholder="Enter your name"
                                className="w-full p-2 border border-pink-200 rounded-md outline-none text-pink-600 focus:ring-2 focus:ring-pink-400 transition-all duration-200"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="block font-medium">City</label>
                            <input
                                type="text"
                                name="city"
                                value={addressInfo.city}
                                onChange={(e) => setAddressInfo({ ...addressInfo, city: e.target.value })}
                                placeholder="Enter your city"
                                className="w-full p-2 border border-pink-200 rounded-md outline-none text-pink-600 focus:ring-2 focus:ring-pink-400 transition-all duration-200"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="block font-medium">Address</label>
                            <input
                                type="text"
                                name="address"
                                value={addressInfo.address}
                                onChange={(e) => setAddressInfo({ ...addressInfo, address: e.target.value })}
                                placeholder="Enter your full address"
                                className="w-full p-2 border border-pink-200 rounded-md outline-none text-pink-600 focus:ring-2 focus:ring-pink-400 transition-all duration-200"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="block font-medium">Pincode</label>
                            <input
                                type="number"
                                name="pincode"
                                value={addressInfo.pincode}
                                onChange={(e) => setAddressInfo({ ...addressInfo, pincode: e.target.value })}
                                placeholder="Enter your pincode"
                                className="w-full p-2 border border-pink-200 rounded-md outline-none text-pink-600 focus:ring-2 focus:ring-pink-400 transition-all duration-200"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="block font-medium">Phone</label>
                            <input
                                type="text"
                                name="mobileNumber"
                                value={addressInfo.mobileNumber}
                                onChange={(e) => setAddressInfo({ ...addressInfo, mobileNumber: e.target.value })}
                                placeholder="Enter your mobile number"
                                className="w-full p-2 border border-pink-200 rounded-md outline-none text-pink-600 focus:ring-2 focus:ring-pink-400 transition-all duration-200"
                            />
                        </div>

                        <div className="flex justify-between mt-4">
                            <button
                                onClick={handleOpen}
                                className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 transition-all duration-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    handleOpen();
                                    cashOnDeliveryFunction();
                                }}
                                className="px-4 py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition-all duration-200"
                            >
                                Place Order
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CashOnDeliveryModal;
